import { render, staticRenderFns } from "./BlockType29.vue?vue&type=template&id=6bc7152c&scoped=true"
import script from "./BlockType29.vue?vue&type=script&lang=ts"
export * from "./BlockType29.vue?vue&type=script&lang=ts"
import style0 from "./BlockType29.vue?vue&type=style&index=0&id=6bc7152c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc7152c",
  null
  
)

export default component.exports